function render( id: number ) {
	return `TX-${id}`
}

export default {
	field: 'id',
	name: 'ID',
	width: '95px',
	render,
}
